<template>
    <div class="bg-white border rounded border-primary d-flex flex-column max-h-300px" :style="minHeightStyle">
        <menu-bar class="bg-primary text-light d-flex flex-wrap align-items-center rounded-top p-2" :editor="editor"/>
        <editor-content class="flex-grow-1 overflow-auto pt-4 p-2 border-0 min-h-150px" :editor="editor"/>
    </div>
</template>

<script>
import {Editor, EditorContent} from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import MenuBar from './MenuBar.vue'
import {Link} from '@tiptap/extension-link'

export default {
    components: {
        MenuBar,
        EditorContent,
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        minHeightPx: {
            type: Number,
            default: -1
        }
    },

    data() {
        return {
            editor: null,
        }
    },

    computed: {
        minHeightStyle() {
            if (this.minHeightPx && this.minHeightPx !== -1) {
                `min-height: ${this.minHeightPx}px;`
            }

            return '';
        }
    },

    watch: {
        value(value) {
            const isSame = this.editor.getHTML() === value

            if (isSame) {
                return
            }

            this.editor.commands.setContent(value, false)
        },
    },

    beforeMount() {
        this.editor = new Editor({
            content: this.value,
            extensions: [
                StarterKit,
                Link.configure({
                    openOnClick: true,
                    autolink: true,
                }),
            ],
            onUpdate: () => {
                this.$emit('input', this.editor.getHTML())
            },
        })
    },

    beforeDestroy() {
        this.editor.destroy()
    },
}
</script>

<style lang="scss">
.ProseMirror:focus {
    outline: none;
}
</style>
